module.exports = __webpack_public_path__ + "img/tasmota-wifi.439953d6.png";